import { render, staticRenderFns } from "./comp_dpc-ImagesSlider.vue?vue&type=template&id=8e25c8d4&scoped=true"
import script from "./comp_dpc-ImagesSlider.vue?vue&type=script&lang=js"
export * from "./comp_dpc-ImagesSlider.vue?vue&type=script&lang=js"
import style0 from "./comp_dpc-ImagesSlider.vue?vue&type=style&index=0&id=8e25c8d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e25c8d4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
